import * as React from 'react';

import { getConfig } from '@constants';

import { getFiledUrl } from '@base/utils';

import { Pic, EAppItemType } from '@components';

import { IAppItemPicProps } from './types';

export class AppItemPic extends React.PureComponent<IAppItemPicProps> {

	render() {
		const {
			type,
			src,
		} = this.props;
		const MAP_SIZE = {
			[EAppItemType.SMALL]: [100, 79],
			[EAppItemType.MEDIUM]: [117, 92],
			[EAppItemType.WIDE]: [375, 142],
			[EAppItemType.HORIZONTAL]: [100, 79],
			[EAppItemType.LARGE]: getConfig().isMobile ? [363, 203] : [539, 303],
		};
		const [width, height] = MAP_SIZE[type];
		const imageSrc = getFiledUrl(src, { width, height, isCropped: true });
		const srcSet = getFiledUrl(src, { width: width * 2, height: height * 2, isCropped: true }) + ' 2x';

		return (
			<Pic
				{...this.props}
				src={imageSrc}
				srcSet={srcSet}
			/>
		);
	}

}
